import { ShareBaseNotification } from 'phoenix/domain';

/**
* @ngdoc service
* @name  sharebase.sbNotificationsService
* 
* @description 
* A service that handles user authentication and provides information
* about the current authenticated user
**/
export function NotificationsServiceFactory(
	$http:ng.IHttpService,
	$q:ng.IQService, 
	settingsService
) {
	return {

		/**
		* @ngdoc method
		* @name sbNotificationsService#getUnreadNotifications
		* @methodOf sharebase.sbNotificationsService
		* @kind function
		*
		* @description
		* Retrieves a user's unread notifications (if applicable).
		*/
		getUnreadNotifications,

		/**
		* @ngdoc method
		* @name sbNotificationsService#getNotifications
		* @methodOf sharebase.sbNotificationsService
		* @kind function
		*
		* @description
		* Retrieves a user's existing notifications.
		*
		* @param {max} max indicates that the API needs to return
		* the {max} latest notifications.
		*/
		getNotifications,

		/**
		* @ngdoc method
		* @name sbNotificationsService#deleteAllNotifications
		* @methodOf sharebase.sbNotificationsService
		* @kind function
		*
		* @description
		* Deletes the user's existing notifications.
		*/
		deleteAllNotifications,

		/**
		* @ngdoc method
		* @name sbNotificationsService#deleteNotification
		* @methodOf sharebase.sbNotificationsService
		* @kind function
		*
		* @description
		* Deletes a specified notification.
		*/
		deleteNotification
	};

	function getUnreadNotifications() {
		return $http.get(settingsService.serverAPIPath + '/notifications/unread')
			.then(resp => resp.data);
	}

	function getNotifications(max) {
		let path = '/notifications';

		if (max > 0) {
			path += '?top=' + max;
		}

		return $http.get(settingsService.serverAPIPath + path)
			.then(resp => resp.data);
	}

	function deleteAllNotifications() {
		return $http.delete(settingsService.serverAPIPath + '/notifications');
	}

	function deleteNotification(notification:ShareBaseNotification) {
		return $http.delete(notification.Links.Self);
	}
}

NotificationsServiceFactory.$inject = [
	'$http',
	'$q',
	'settingsService'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/notificationService.ts